// ============================================================================
// vagolap.js — szöveg a vágólapra (kiemelve a chatView.js-ből 2026-10-19-én, hogy a hibakereső adatok másolása is használhassa).
// ============================================================================

/**
 * Szöveg a vágólapra (2026-10-03, tagi kérésre: "Másolás" gomb az
 * üzeneteken). ELSŐKÉNT a modern, biztonságos Clipboard API-t próbálja -
 * ehhez a lapnak HTTPS-en és fókuszban kell lennie, mindkettő adott egy
 * gombra kattintás pillanatában. TARTALÉK (régebbi böngésző, vagy a
 * Clipboard API bármilyen okból hiányzik): egy láthatatlan, ideiglenes
 * textarea + a régi `execCommand("copy")` - ez szinte minden böngészőn
 * működik, cserébe elavultnak számít, ezért csak tartalékként szerepel.
 */
export async function vagolapraMasol(szoveg) {
  if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
    await navigator.clipboard.writeText(szoveg);
    return;
  }
  const ta = document.createElement("textarea");
  ta.value = szoveg;
  ta.style.position = "fixed";
  ta.style.top = "-1000px";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  try {
    const sikerult = document.execCommand("copy");
    if (!sikerult) throw new Error("execCommand('copy') nem sikerült");
  } finally {
    ta.remove();
  }
}
